import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dictionary" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  style: {"margin-top":"50px","font-size":"32px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslateWord = _resolveComponent("TranslateWord")!
  const _component_FindWord = _resolveComponent("FindWord")!
  const _component_DictionaryTable = _resolveComponent("DictionaryTable")!
  const _component_VPagination = _resolveComponent("VPagination")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoader)
      ? (_openBlock(), _createBlock(_component_TranslateWord, {
          key: 0,
          isPagesNull: _ctx.pagesDictionary == null,
          index: _ctx.currentColumn - 1
        }, null, 8, ["isPagesNull", "index"]))
      : _createCommentVNode("", true),
    (!_ctx.isLoader && _ctx.pagesDictionary != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_FindWord, {
            style: {"margin-top":"50px"},
            onFindItem: _ctx.findModule
          }, null, 8, ["onFindItem"]),
          _createVNode(_component_DictionaryTable, { currentPage: _ctx.currentColumn }, null, 8, ["currentPage"]),
          _createVNode(_component_Paginator, {
            onNextPage: _ctx.nextPage,
            onPreviousPage: _ctx.previousPage
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VPagination, {
                modelValue: _ctx.currentColumn,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentColumn) = $event)),
                  _ctx.editPage
                ],
                pages: _ctx.pagesDictionary,
                "range-size": 1,
                "active-color": "#dddddd"
              }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["onNextPage", "onPreviousPage"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pagesDictionary == null && !_ctx.isLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.t("dictionary.empty")), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoader)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 3 }))
      : _createCommentVNode("", true)
  ]))
}